import dataSources from "@/data/cloud/firebase/mixins/dataSources.js";
import changeFirebase from "@/data/cloud/firebase/mixins/changeFirebase.js";
import { mapGetters } from "vuex";

export default {
  // eslint-disable-next-line
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["getDetailBasic", "getTransitions"])
  },
  mixins: [dataSources, changeFirebase],
  methods: {
    enableDocumentItemAdd() {
      let logic = null;
      let arch = this.getDetailBasic.ver;
      let status = null;
      if (this.getTransitions !== null && this.getTransitions !== undefined) {
        let flow = this.getTransitions.flow;
        status = flow[flow.length - 1].title;
      }
      // CHECK
      if (arch === "A" && arch !== undefined && arch !== null) {
        logic = false;
      } else if (status === "Closed" || status === "Cancelled") {
        logic = false;
      } else if (this.getDetailBasic.tag === "M7") {
        logic = false;
      } else {
        logic = true;
      }
      return logic;
    },
    enableDocumentItemEdit() {
      let logic = null;
      let arch = this.getDetailBasic.ver;
      let status = null;
      if (this.getTransitions !== null && this.getTransitions !== undefined) {
        let flow = this.getTransitions.flow;
        status = flow[flow.length - 1].title;
      }
      // CHECK
      if (arch === "A" && arch !== undefined && arch !== null) {
        logic = false;
      } else if (status === "Closed" || status === "Cancelled") {
        logic = false;
      } else if (this.getDetailBasic.tag === "M7") {
        logic = false;
      } else {
        logic = true;
      }
      return logic;
    },
    enableDocumentItemRead() {
      let logic = null;
      let arch = this.getDetailBasic.ver;
      let status = null;
      if (this.getTransitions !== null && this.getTransitions !== undefined) {
        let flow = this.getTransitions.flow;
        status = flow[flow.length - 1].title;
      }
      // CHECK
      if (arch === "A" && arch !== undefined && arch !== null) {
        logic = false;
      } else if (status === "Closed" || status === "Cancelled") {
        logic = false;
      } else if (this.getDetailBasic.tag === "M7") {
        logic = false;
      } else {
        logic = true;
      }
      return logic;
    },
    setDetailBasicSave(db, did, value) {
      // console.log("");
      // console.log(">>> SET DETAIL BASIC SAVE <<<");
      // console.log(db);
      // console.log(did);
      // console.log(value);
      // let did = this.getDetailBasic.did;
      // let db = this.defineDataSourceFromTag(this.getDetailBasic.tag);
      this.changeBasicSave(db, did, value);
    },
    setDetailBasicList(db, did, value) {
      // console.log("");
      // console.log(">>> SET DETAIL BASIC LIST <<<");
      // console.log(db);
      // console.log(did);
      // console.log(value);
      // let did = this.getDetailBasic.did;
      // let db = this.defineDataSourceFromTag(this.getDetailBasic.tag);
      this.changeBasicList(db, did, value);
    }
  }
};
